import { BlogTagsByBrandDocument, BlogTagsByBrandQuery } from '@/graphql/__generated/sdk';
import { getGraphQLClientForContentful } from '@/graphql/client';
import { logWarning } from '@/utils/miscUtils';

const BLOG_TAGS_PAGE_SIZE = 200;

export const getAllBlogTagListByBrand = async (brandName: string, url: string, preview: boolean) => {
	try {
		if (!brandName) {
			return [] as string[];
		}

		const gqlClient = getGraphQLClientForContentful(url, preview);

		if (gqlClient === null) {
			logWarning('GQL_CLIENT_IS_NULL: missing token for fetching contentful data');
			throw new Error('gqlClient is null');
		}

		const tags = new Set<string>();
		let skip = 0;
		let total = 0;

		do {
			const response = await gqlClient
				.query(BlogTagsByBrandDocument, {
					limit: BLOG_TAGS_PAGE_SIZE,
					skip,
					brandName,
					order: ['date_DESC'],
					preview,
				})
				.toPromise();

			const collection = response.data?.blogDetailsPageCollection;
			const items: NonNullable<NonNullable<BlogTagsByBrandQuery['blogDetailsPageCollection']>['items']> =
				collection?.items ?? [];

			items.forEach((item) => {
				item?.tags?.forEach((tag: string | null | undefined) => {
					if (tag) {
						tags.add(tag);
					}
				});
			});

			total = collection?.total ?? items.length;
			skip += items.length;

			if (items.length === 0) {
				break;
			}
		} while (skip < total);

		return Array.from(tags).sort((left, right) => left.localeCompare(right));
	} catch (error) {
		logWarning(`Error fetching blog tag list by brand error: ${String(error)}`);
		return [] as string[];
	}
};
